class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    if (!this.summary || !this.details) {
      return;
    }

    this.summary.addEventListener('click', this.handleSummaryClick.bind(this));

    this.summary.setAttribute('role', 'button');
    this.summary.setAttribute(
      'aria-expanded',
      this.details.hasAttribute('open')
    );

    if (this.summary.nextElementSibling.getAttribute('id')) {
      this.summary.setAttribute(
        'aria-controls',
        this.summary.nextElementSibling.id
      );
    }
  }

  handleSummaryClick(event) {
    event.preventDefault();

    if (this.details.open) {
      this.details.classList.remove('is-open');
      setTimeout(() => {
        this.details.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', false);
      }, 500);
    } else {
      this.details.classList.add('is-open');
      this.details.setAttribute('open', 'true');
      this.summary.setAttribute('aria-expanded', true);
    }
  }
}
customElements.define('accordion-item', AccordionItem);
